import { ArrowLeft } from "lucide-react";

type MobileHeaderProps = {
  title?: string;
  onBack?: () => void;
  className?: string;
};

export default function MobileHeader({
  title,
  onBack,
  className = "",
}: MobileHeaderProps) {
  return (
    <div className="content relative bg-white shadow-sm sticky top-0 z-50">
      <div
        className={`relative flex items-center justify-between p-3 bg-gradient-to-r from-green-800 to-green-600
            ${className}`}
      >
        <div className="flex items-center space-x-4 w-full">
          <button className="flex items-center" onClick={onBack}>
            <ArrowLeft className="w-6 h-6 text-white" />
          </button>
          <p className="text-base cursor-default font-medium text-white">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
}
